export default "__VITE_ASSET__CR9q8QPe__"